import { Directive, Input } from '@angular/core';
import { CdkRowDef } from '@angular/cdk/table';

@Directive({
  selector: '[mcraiRowDef]',
  providers: [{ provide: CdkRowDef, useExisting: RowDefDirective }]
})
export class RowDefDirective<T> extends CdkRowDef<T> {
  @Input('mcraiRowDefColumns') columns;
  @Input('mcraiRowDefWhen') when;
}
